import PropTypes from 'prop-types';

// mui
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// hooks
import useResponsive from 'hooks/useResponsive';

// components
import CustomImage from 'components/CustomImage';

const circleCardDefaultPropCircleData = {
  id: '',
  url: '',
  title: '',
  image: {
    url: '',
  },
};

const CircleCard = ({ circleData = circleCardDefaultPropCircleData, isLastElement = false, testId = null }) => {
  const { url, image, title } = circleData;

  const isTablet = useResponsive('down', 'md');

  const imageDimension = 130;

  return (
    <Box
      sx={{
        display: 'flex',
        rowGap: '10px',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        mr: isLastElement && isTablet ? '10px' : 0,
      }}
      data-testid={`fyp-discover-section-container-circles-circle-${testId}`}
    >
      <Box sx={{ borderRadius: '50%', overflow: 'hidden', width: imageDimension, height: imageDimension }}>
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`fyp-discover-section-container-circles-circle-${testId}-image-url`}
        >
          <CustomImage unoptimized alt={title} src={image?.url} width={imageDimension} height={imageDimension} />
        </a>
      </Box>
      <Typography
        href={url}
        display="block"
        whiteSpace="nowrap"
        variant="subtitle1"
        textAlign="center"
        data-testid={`fyp-discover-section-container-circles-circle-${testId}-title`}
      >
        {title}
      </Typography>
    </Box>
  );
};

CircleCard.propTypes = {
  circleData: PropTypes.shape({
    id: null,
    url: null,
    title: null,
    image: PropTypes.shape({ url: PropTypes.string }),
  }),
  isLastElement: PropTypes.bool,
  testId: PropTypes.number,
};

export default CircleCard;
